import Banner from '../banner';
import './styles.scss';
import copy from '../../../copy.json';
import { ASSETS } from '../../../assets';

const CLASS_NAME="home-mobile"

const MobileHomePage = () => {
    const homeCopy = copy.home;
    const renderCoreCompetencies = () => {
        return homeCopy.coreCompetancies.map((text, index) => {
            return <p className={`${CLASS_NAME}-core-competency`} key={index}>{text}</p>
        })
    }

    return <>
        <Banner />
        <div className={`${CLASS_NAME}-container`}>
            <div className={`${CLASS_NAME}-summary`}>
                <p>{homeCopy.summary.section1}</p>
                <p>{homeCopy.summary.section2}</p>
            </div>
            <hr/>
            <div className={`${CLASS_NAME}-mission`}>
                <h2>{homeCopy.missionHeading}</h2>
                <p>{homeCopy.mission}</p>
            </div>
            <hr />
            <div className={`${CLASS_NAME}-core-competencies`}>
                <h2>{homeCopy.coreCompetanciesHeading}</h2>
                {renderCoreCompetencies()}
            </div>
            <hr />
            <div className={`${CLASS_NAME}-images`}>
                <img src={ASSETS.SAM_MBE} alt="SAM MBE" className="mbe" />
                <img src={ASSETS.VENDOR_PROFILE} alt="Vendor Profile" className="vendor-profile" />
            </div>
            <hr />
            <div className={`${CLASS_NAME}-mbe flex-justify-center`}>
                <img src={ASSETS.MBE_CERTIFICATION} alt="MBE Certification" />
            </div>
            <hr />
            <div className={`${CLASS_NAME}-images-2 flex-justify-center`}>
                <img src={ASSETS.VERIFIED_VENDOR} alt="Verified Vendor" className="verified-vendor" />
                <img src={ASSETS.ACQUISITION_PROGRAM} alt="Acquisition Program" className="acquisition-program" />
            </div>
            <p>{homeCopy.simplifiedAcquisitionProgram}</p>
        </div>
    </>
}

export default MobileHomePage;